import { useMutation } from '@apollo/client/react';
import { useError } from 'contexts/error';
import { useInfo } from 'contexts/info';

const useResourceMutation = (mutation, { errorKey, info, onCompleted, onError, ...options } = {}) => {
  const setError = useError();
  const setInfo = useInfo();

  return useMutation(mutation, {
    ...options,
    onCompleted: (data) => {
      if (info) setInfo(info);
      onCompleted?.(data);
    },
    onError: (mutationError) => {
      if (errorKey) setError(errorKey);
      onError?.(mutationError);
    },
  });
};

export default useResourceMutation;
